import { ReactNode, useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router';
import { ProtocolContext } from './ProtocolContext';
import { Protocol, ProtocolsApi } from '../../../api/protocolsApi/ProtocolsApi';

interface ProtocolProviderProps {
  children: ReactNode;
}

export const ProtocolProvider = ({ children }: ProtocolProviderProps) => {
  const { id } = useParams<{ id: string; page: string }>();
  const [protocol, setProtocol] = useState<Protocol | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const api = ProtocolsApi();

  const fetchProtocol = useCallback(async () => {
    if (!id) {
      setError('Protocol ID is missing');
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);
      const response = await api.getOneById(Number(id));
      setProtocol(response.data);
    } catch (err: any) {
      setError(err?.response?.data?.message || 'Failed to load protocol');
      setProtocol(null);
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchProtocol();
  }, []);

  const refetch = useCallback(() => {
    fetchProtocol();
  }, [fetchProtocol]);

  return (
    <ProtocolContext.Provider
      value={{ protocol, loading, error, setLoading, refetch, setProtocol }}>
      {children}
    </ProtocolContext.Provider>
  );
};
